import { render, staticRenderFns } from "./dashboardAchievements.vue?vue&type=template&id=789f12d9&scoped=true&"
import script from "./dashboardAchievements.vue?vue&type=script&lang=js&"
export * from "./dashboardAchievements.vue?vue&type=script&lang=js&"
import style0 from "./dashboardAchievements.vue?vue&type=style&index=0&id=789f12d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789f12d9",
  null
  
)

export default component.exports